// extracted by mini-css-extract-plugin
export default {"clientMenuContainer":"ClientMenuIconStyles_clientMenuContainer__utIiZ","clientMenuIcon":"ClientMenuIconStyles_clientMenuIcon__1TLLS"};